// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"fc8ec119","9663":"73522817"}[chunkId] + ".chunk.css";
};